<div class="content">
  <div class="header" *ngIf="!showSearchBoxCountGreaterThan || (showSearchBoxCountGreaterThan && filteredArray.length > showSearchBoxCountGreaterThan)">
    <ion-item>
      <ion-label>
        <b> Search: </b>
      </ion-label>
      <ion-input #searchTextBox placeholder="Type to search..." (ionChange)="onChange($event)"> </ion-input>
    </ion-item>
  </div>
  <div class="no-options" *ngIf="value.length === 0">
    <div>No options available</div>
    <div *ngIf="searchText.length">Please adjust your search.</div>
  </div>
  <ion-list>
    <div class="items">
      <ng-container *ngIf="multiple; else single">
        <ion-item *ngFor="let item of value; let i = index">
          <ion-checkbox slot="start" [value]="item" (ionChange)="onMultipleSelect($event)"> </ion-checkbox>
          <ion-label>
            {{ item[displayProperty] }}
          </ion-label>
        </ion-item>
      </ng-container>
      <ng-template #single>
        <ion-item *ngFor="let item of value; let i = index">
          <ion-label (click)="onSingleSelect(item)">
            {{ item[displayProperty] }}
          </ion-label>
        </ion-item>
      </ng-template>
    </div>
  </ion-list>
  <app-footer-buttons-spacer *ngIf="multiple"></app-footer-buttons-spacer>
</div>
<app-footer-buttons
  *ngIf="multiple"
  [leftButton]="{ text: 'Close', sizing: 'expand' }"
  [rightButton]="{ text: 'Done', sizing: 'expand' }"
  (leftButtonClicked)="onClose()"
  (rightButtonClicked)="onDone()"></app-footer-buttons>
